import React, {useEffect, useState} from "react";
import Joyride from "react-joyride";
import {useTheme} from "@mui/material/styles";
import {useTranslation} from "react-i18next";

function Tour(props) {
    const theme = useTheme();
    const {t} = useTranslation();
    const [tourFinished, setTourFinished] = useState(false);

    // order of TOUR_STEPS result in order they are run through
    const TOUR_STEPS = [
        {
            target: ".addDatasetButton",
            content: t("tour.AddDatasetButton"),
            // tooltipComponent:t('tour.BeaconTooltip')
        },
        {
            target: ".currentDatasetSelector",
            content: t("tour.CurrentDatasetSelector"),
        },
        {
            target: ".addExperimentButton",
            content: t("tour.AddExperimentButton"),
        },
        {
            target: ".currentExperimentSelector",
            content: t("tour.CurrentExperimentSelector"),
        },
        {
            target: ".currentExperimentProgress",
            content: t("tour.CurrentExperimentProgress"),
        },
    ];

    const handleTourFinish = (data) => {
        const {status, action} = data;
        if (
            // tour was skipped
            (status === "skipped" && action === "skip") ||
            // tour reached end
            action === "reset"
        ) {
            setTourFinished(true);
            // set localStorage when tour is finished
            window.localStorage.setItem("tourFinished", "true");
        }
    };

    // prevent Tour from being shown again if it was already finished (saved in localStorage)
    useEffect(() => {
        const storedTourFinished = window.localStorage.getItem("tourFinished");
        if (storedTourFinished) {
            setTourFinished(JSON.parse(storedTourFinished));
        }
    }, []);

    return (
        <div>
            {!tourFinished && (
                <Joyride
                    run={props.userIsLoggedIn}
                    steps={TOUR_STEPS}
                    continuous
                    showProgress
                    showSkipButton
                    // spotlightClicks={true} enables clicking outside Tutorial
                    styles={{
                        options: {
                            arrowColor: "#fff",
                            backgroundColor: "#fff",
                            beaconSize: 36,
                            overlayColor: "rgba(0,0,0,0.5)",
                            primaryColor: theme.palette.info.main,
                            spotlightShadow: "0 0 15px rgba(0, 0, 0, 0.5)",
                            textColor: "#333",
                            width: undefined,
                            zIndex: 2000,
                        },
                    }}
                    locale={{
                        skip: t("tour.SkipButton"),
                        open: t("tour.BeaconTooltip"),
                        next: t("tour.NextButton"),
                        back: t("tour.BackButton"),
                    }}
                    callback={handleTourFinish}
                />
            )}
        </div>
    );
}

export default Tour;
